
import React, { useState } from "react";
import {
  Button,
  Typography,
  Grid,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginRight: theme.spacing(1),
    width: "90%",
    outline: "none",
  },
  button: {
    // backgroundColor: "rgba(12, 77, 162, 1) !important",
    color: "white !important",
    padding: "10px 18px",
    height: "35px",
    width: "89px",
    marginTop: "10px",
    // "&:hover": {
    //   backgroundColor: "rgba(8, 58, 130, 1)",
    // },
  },
  pickerContainer: {
    backgroundColor: "#ffffff",
    borderRadius: "9px",
    padding: "0px 15px",
    border: "2px solid rgb(12, 77, 162)",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
    height: "46px",
    width: "85%",
    marginLeft: "5%"
  },
  dateOfBirthHeader: {
    textAlign: "center",
    fontWeight: "bold",
    fontSize: "14px",
    color: "rgb(12, 77, 162)",
    marginBottom: "10px",
  },
  msgContentWrapper: {
    border: "8px solid rgba(244, 176, 53, 0.8)",
    borderRadius: "20px",
    backgroundColor: "rgba(245, 243, 243, 1)",
    padding: "15px",
    width: "83%",
    marginLeft: "8px",
  },
  noUnderline: {
    "& .MuiOutlinedInput-root": {
      "& .MuiOutlinedInput-notchedOutline": {
        border: "none",
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "transparent",
      },
      "& .MuiInputBase-input": {
        fontSize: "18px", // Increase the font size of the date text
      },
    },
    "& .MuiInput-underline:before, & .MuiInput-underline:after": {
      borderBottom: "none !important", // Remove underline
    },
  },
  calendarStyle: {
    "& .MuiPickersCalendarHeader-switchHeader": {
      fontSize: "20px", // Increase size of the calendar header text
    },
    "& .MuiPickersDay-dayWithMargin": {
      fontSize: "18px", // Increase size of the day text
    },
  },
  errorMessage: {
    color: "red",
    marginTop: theme.spacing(1),
    textAlign: "center",
  },
}));

export default function DateofBirthCard({ onSendWorkflowDateOfBirth, language }) {
  const classes = useStyles();
  const [selectedDate, setSelectedDate] = useState(null);
  const [error, setError] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    setError("");
  };

  const validateDate = (date) => {
    const today = new Date();
    if (!date || isNaN(date)) return "Invalid date format";

    const [day, month, year] = [
      date.getDate(),
      date.getMonth() + 1,
      date.getFullYear(),
    ];

    if (date > today) return "Date cannot be in the future";
    if (day < 1 || day > 31) return "Invalid day entered";
    if (month < 1 || month > 12) return "Invalid month entered";
    if (day === 29 && month === 2 && !isLeapYear(year)) return "Not a leap year";

    return "";
  };

  const isLeapYear = (year) => {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
  };

  const handleSend = () => {
    const validationError = validateDate(selectedDate);
    if (validationError) {
      setError(validationError);
      return;
    }

    onSendWorkflowDateOfBirth(
      selectedDate.toLocaleDateString("en-GB").replace(/\//g, ""),
      language
    );
    setIsDisabled(true);
    setIsSubmitted(true)
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSend();
    }
  };

  return (
    <div className={classes.msgContentWrapper}>
      <Grid item xs>
        <Typography className={classes.dateOfBirthHeader}>
          {language === "en"
            ? "Please enter your date of birth"
            : language === "hn"
            ? "आपका जन्म तारीख प्रवेश करे"
            : "ଆପଣଙ୍କର ଜନ୍ମ ତାରିଖ ପ୍ରବେଶ କରନ୍ତୁ |"}
        </Typography>
      </Grid>

      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          className={`${classes.noUnderline} ${classes.pickerContainer} ${classes.calendarStyle}`}
        >
          <KeyboardDatePicker
            autoOk
            variant="inline"
            format="dd/MM/yyyy"
            disableFuture
            placeholder="DD/MM/YYYY"
            value={selectedDate}
            onChange={handleDateChange}
            disabled={isDisabled}
            autoFocus
            InputAdornmentProps={{ position: "start" }}
            InputProps={{
              inputProps: {
                inputMode: "numeric",
                pattern: "[0-9]*",
                onKeyPress: (event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                },
                onPaste: (event) => {
                  const paste = event.clipboardData.getData("Text");
                  if (!/^\d+$/.test(paste)) {
                    event.preventDefault();
                  }
                },
              },
            }}
            error={false}
            helperText={null}
          />
        </Grid>
      </MuiPickersUtilsProvider>

      {error && <Typography className={classes.errorMessage}>{error}</Typography>}

      <Grid container justifyContent="center">
        <Button
          variant="contained"
          onClick={handleSend}
          disabled={isDisabled}
          className={classes.button}
          // style={{    height: "28px",
          //   width:" 130px",
          //   marginLeft: "15px"}}
          style={{backgroundColor:isSubmitted?"grey":"rgba(12, 77, 162, 1)"}}
        >
          Submit
        </Button>
      </Grid>
    </div>
  );
}
